import React, { useState, useEffect } from "react";
import PageHeader from "../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import "../../../../Assets/Styles/SystemSettings.scss";
import { BrowserRouter } from "react-router-dom";
import LocalizationForm from "../../../Dashboard/Components/SystemSettings/Localization/LocalizationForm";
import { Config } from "../../../../Config";
import axios from "axios";
import Tabs from "../../../Dashboard/Components/SystemSettings/Localization/Components/Tabs";
import "../../../../Assets/Styles/Localization.scss";

const Localization = (props) => {
  const [AllLanguages, setAllLanguages] = useState([]);
  const [ItemToEdit, setItemToEdit] = useState(undefined);
  const [Categories] = useState([
    { id: "NAV_MENU", name: "Nav. Menu" },
    { id: "DASHBOARD", name: "Dashboard" },
    { id: "JOBS", name: "Jobs" },
    { id: "PROJECTS", name: "Projects" },
    { id: "ACTIVITIES", name: "Activities" },
    { id: "EMPLOYEES", name: "Employees" },
    { id: "POSITIONS", name: "Positions" },
    { id: "TRAININGS", name: "Trainings" },
    { id: "SKILLS", name: "Skills" },
    { id: "SYSTEM_SETTINGS", name: "System settings" },
    { id: "GENERAL", name: "General" },
    { id: "AUTH", name: "Auth" },
    { id: "CANDIDATES", name: "Candidates" },
    { id: "AI", name: "AI" },
    { id: "JPA", name: "JPA" },
    { id: "WIZARD", name: "Wizard" },
    { id: "VALIDATIONS", name: "Validations" },
    { id: "INFORMATIVE", name: "Informative" },
    { id: "GREETINGS", name: "Greetings" },
    { id: "PROFILE", name: "Profile" },
    { id: "NOTIFICATIONS", name: "Notifications" },
    { id: "CHAT_BOT", name: "CX Copilot" },
    { id: "WALKTHROUGH", name: "Walkthrough" },
  ]);
  const [SelectedCategory, setSelectedCategory] = useState({
    id: "NAV_MENU",
    name: "Nav. Menu",
  });
  const [PreviouslySelectedCategory, setPreviouslySelectedCategory] = useState({
    id: "NAV_MENU",
    name: "Nav. Menu",
  });
  const [Labels, setLabels] = useState([]);
  const [LangOptions] = useState([{ name: "German", id: "DE" }]);
  const [ResIsEmpty, setResIsEmpty] = useState(false);
  const [EditIsActive, setEditIsActive] = useState(false);
  const [SecondLangLabels, setSecondLangLabels] = useState([]);
  const [SearchIsOpen, setSearchIsOpen] = useState(false);
  const [TotalElements, setTotalElements] = useState(0);

  useEffect(() => {
    getAllLanguages();
    searchLabels(undefined, SelectedCategory.id, false, 5, 0);
  }, []);

  const searchLabels = (Language, Category, IsResetSearch, Size, Start) => {
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/labels/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          labelCategory: Category,
          labelTextLike: "",
        },
        size: Size,
        start: Start,
      },
    };
    // Searched keyword
    if (document.getElementById("search-input")) {
      Req.data.criteria.labelTextLike =
        document.getElementById("search-input").value;
    }
    // Search category
    if (Category === undefined) {
      Req.data.criteria.labelCategory = SelectedCategory.id;
    } else if (Category === null && SearchIsOpen) {
      delete Req.data.criteria.labelCategory;
    }

    if (IsResetSearch) {
      Req.data.criteria.labelCategory = "NAV_MENU";
      setSelectedCategory({
        id: "NAV_MENU",
        name: "Nav. Menu",
      });
    }

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setLabels([]);

        setLabels(Res.data.results);
        setTotalElements(Res.data.totalElements);

        if (Language !== "EN" && Category === null) {
          setSecondLangLabels(Res.data.results);
        }
        // handling empty state
        if (Res.data.results.length === 0) {
          setResIsEmpty(true);
        } else {
          setResIsEmpty(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getAllLanguages = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/language/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAllLanguages(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  // This function is executed when a category chip is clicked
  const selectCategory = (Category) => {
    setSearchIsOpen(false);

    // handling switching from search to the selected category
    let SearchKeyword = document.getElementById("search-input").value;
    if (SearchKeyword.length > 0) {
      document.getElementById("clear-btn").click();
    }
    setLabels([]);
    setTimeout(() => {
      let Size = 5;
      if (document.getElementById("pre-selected-row-per-page")) {
        Size = parseInt(
          document.getElementById("pre-selected-row-per-page").innerHTML
        );
      }

      if (document.getElementById("1-page-btn")) {
        document.getElementById("1-page-btn").click();
      } else {
        searchLabels(undefined, Category.id, false, Size, 0);
      }
    }, 100);
    setEditIsActive(false);
    setSelectedCategory(Category);
    setPreviouslySelectedCategory(Category);
    setItemToEdit(undefined);
  };

  return (
    <BrowserRouter basename="/home/localization/">
      <div className="localization main-content security-settings system-settings">
        <PageHeader PageName={translateText("localization")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("system_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("localization")}</p>
          </div>
        </div>
        <Tabs
          Categories={Categories}
          SelectedCategory={SelectedCategory}
          SelectCategory={(Category) => selectCategory(Category)}
          SearchIsOpen={SearchIsOpen}
          LangData={props.LangData}
        />
        <>
          {AllLanguages.length === 0 ? null : (
            <LocalizationForm
              AllLanguages={AllLanguages}
              LangData={props.LangData}
              UserLanguage={props.UserLanguage}
              Categories={Categories}
              Category={{ id: "NAV_MENU", name: "Nav. Menu" }}
              SelectedCategory={SelectedCategory}
              PreviouslySelectedCategory={PreviouslySelectedCategory}
              Labels={Labels}
              LangOptions={LangOptions}
              SearchLabels={(Lang, Cat, IsResetSearch, Size, NewStart) =>
                searchLabels(Lang, Cat, IsResetSearch, Size, NewStart)
              }
              ResIsEmpty={ResIsEmpty}
              SetEditIsActive={(Bool) => setEditIsActive(Bool)}
              EditIsActive={EditIsActive}
              SecondLangLabels={SecondLangLabels}
              SetSearchIsOpen={(Bool) => setSearchIsOpen(Bool)}
              TotalElements={TotalElements}
              SearchIsOpen={SearchIsOpen}
              ItemToEdit={ItemToEdit}
              SetItemToEdit={(Item) => setItemToEdit(Item)}
            />
          )}
        </>
      </div>
    </BrowserRouter>
  );
};

export default Localization;
